/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled    from 'styled-components';
import { Media } from '../../../styles/utilities';


/*********************************************************************************
 2. Component
 *********************************************************************************/

export const StyledContentWrapper = styled.section`
  ${Media.Tablet`
    justify-content: center;
    display: flex;
  `}
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledContentWrapper/index.js